import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidatorFn,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "src/app/shared/shared.service";
import { PAGE_VIEW_TYPE } from "src/app/utility/Constants";
import { SubContractorService } from "../../subContractor-service";
import { DatePipe } from "@angular/common";
import { ConfirmationDialog, ConfirmationWithReasonComponent } from "src/app/pages/comman-components/confirmation-with-reason/confirmation-with-reason.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-contractor-payment-request-add",
  templateUrl: "./contractor-payment-request-add.component.html",
  styleUrls: ["./contractor-payment-request-add.component.scss"],
})
export class ContractorPaymentRequestAddComponent implements OnInit {
  isLoading = false;
  ContractorPaymentRequestForm: FormGroup;
  isEditMode = false;
  viewType: string = PAGE_VIEW_TYPE.ADD;
  sitedata: any[] = [];
  Contractordata: any[] = [];
  dataforsubcontractor: any = [];
  branchId: any;
  selectedId: number | string;
  currentReceiptData: any = null;
  obj: any;

  ProductColumns = [
    "Select",
    "W/O No",
    "Invoice No",
    "Invoice Date",
    "Bill Amt",
    "Paid Amt",
  ];

  constructor(
    private formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    public sharedservice: SharedService,
    private snackBar: MatSnackBar,
    private SubContractorService: SubContractorService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.initializeForm({});
    this.branchId = localStorage.getItem("branch");

    this._route.queryParams.subscribe((params) => {
      this.viewType = params.viewType || PAGE_VIEW_TYPE.ADD;
      this.isEditMode = this.viewType === PAGE_VIEW_TYPE.UPDATE;
    });

    this.loadInitialData();
  }

  // Custom validator to check if PaidAmount is not greater than TotalOutstan
  paidAmountValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.parent) {
        return null;
      }

      const paidAmount = parseFloat(control.value) || 0;
      const totalOutstanding =
        parseFloat(control.parent.get("TotalOutstan")?.value) || 0;

      if (paidAmount > totalOutstanding && totalOutstanding > 0) {
        return {
          paidAmountExceedsOutstanding: {
            paidAmount: paidAmount,
            totalOutstanding: totalOutstanding,
          },
        };
      }

      return null;
    };
  }

  onContractorSelect(item: any) {
    this.obj = item;
    // Set TDS field with tdsPer value from API
    this.ContractorPaymentRequestForm.patchValue({
      TDS: item?.tdsPer || 0,
    });
    this.fetchSUBWOByContractorId(item.contractorKey);
  }

  onSelectsite(item) {}

  onSelectdataforsubcontarctor(item) {
    this.ContractorPaymentRequestForm.patchValue({
      site: item.siteName || "",
    });

    this.getbillentry(item.subConWoKey);
  }

  // Updated fetchSUBWOByContractorId to return a Promise
  fetchSUBWOByContractorId(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.SubContractorService.getSubContractort(id).subscribe(
        (response) => {
          if (response) {
            this.dataforsubcontractor = response;
            resolve(response);
          } else {
            reject('No sub-contractor data found');
          }
        },
        (error) => reject(error)
      );
    });
  }

  getbillentry(id: number) {
    this.sharedservice.getbillentry(id).subscribe((response) => {
      if (response?.data?.length > 0) {
        this.productDetails.clear();

        this.ContractorPaymentRequestForm.patchValue({
          Amt: "0.00",
        });

        response?.data?.forEach((item: any) => {
          const group = this.formBuilder.group({
            isSelected: [false],
            no: [item?.conBillEntryKey || ""],
            WONo: [item?.workOrderNumber || ""],
            InvoiceNo: [item?.conBillEntryNo || ""],
            InvoiceDate: [
              this.datePipe.transform(item?.invoiceDate, "MM/dd/yyyy") || "",
            ],
            BillAmt: [item?.grossAmount || ""],
            PaidAmt: [item?.billPaidAmount || ""],
          });

          this.productDetails.push(group);
        });

        // Re-validate PaidAmount after updating TotalOutstan
        this.ContractorPaymentRequestForm.get(
          "PaidAmount"
        )?.updateValueAndValidity();
      }
    });
  }

  // New method to handle bill entry loading for update scenario
  getbillentryForUpdate(subConWoKey: number, selectedBillEntryKeys: number[]): void {
    this.sharedservice.getbillentry(subConWoKey).subscribe((response) => {
      if (response?.data?.length > 0) {
        this.productDetails.clear();

        let totalSelectedBillAmt = 0;
        let totalSelectedPaidAmt = 0;

        response?.data?.forEach((item: any) => {
          // Check if this item is selected based on conBillEntryKeysSet
          const isSelected = selectedBillEntryKeys.includes(item?.conBillEntryKey);
          
          const group = this.formBuilder.group({
            isSelected: [isSelected],
            no: [item?.conBillEntryKey || ''],
            WONo: [item?.workOrderNumber || ''],
            InvoiceNo: [item?.conBillEntryNo || ''],
            InvoiceDate: [
              this.datePipe.transform(item?.invoiceDate, 'MM/dd/yyyy') || '',
            ],
            BillAmt: [item?.grossAmount || ''],
            PaidAmt: [item?.billPaidAmount || ''],
          });

          this.productDetails.push(group);

          // Calculate totals for selected items
          if (isSelected) {
            const billAmt = parseFloat(item?.grossAmount) || 0;
            const paidAmt = parseFloat(item?.billPaidAmount) || 0;
            totalSelectedBillAmt += billAmt;
            totalSelectedPaidAmt += paidAmt;
          }
        });

        // Calculate and set the total outstanding amount
        const totalOutstanding = totalSelectedBillAmt - totalSelectedPaidAmt;

        // Update form with calculated values
        this.ContractorPaymentRequestForm.patchValue({
          Amt: totalSelectedBillAmt.toFixed(2),
          TotalOutstan: totalOutstanding > 0 ? totalOutstanding.toFixed(2) : '0.00',
        });

        // Re-validate PaidAmount after updating TotalOutstan
        this.ContractorPaymentRequestForm.get('PaidAmount')?.updateValueAndValidity();
      }
    });
  }

  calculateTotalSelectedAmount(): number {
    let total = 0;
    this.productDetails.controls.forEach((control) => {
      if (control.get("isSelected")?.value) {
        const billAmt = parseFloat(control.get("BillAmt")?.value) || 0;
        total += billAmt;
      }
    });
    return total;
  }

  // Calculate TDS amount and ActualPayable
  calculateTDSAndActualPayable(): void {
    const paidAmount =
      parseFloat(this.ContractorPaymentRequestForm.get("PaidAmount")?.value) ||
      0;
    const tdsPercentage =
      parseFloat(this.ContractorPaymentRequestForm.get("TDS")?.value) || 0;

    const tdsAmount = (paidAmount * tdsPercentage) / 100;
    const actualPayable = paidAmount - tdsAmount;

    this.ContractorPaymentRequestForm.patchValue({
      ActualPayable: actualPayable.toFixed(2),
    });
  }

  setFormState() {
    if (this.ContractorPaymentRequestForm) {
      if (this.viewType === PAGE_VIEW_TYPE.VIEW) {
        this.ContractorPaymentRequestForm.disable({ emitEvent: false });
      } else {
        this.ContractorPaymentRequestForm.enable({ emitEvent: false });

        this.ContractorPaymentRequestForm.get("EmailId")?.disable();
        this.ContractorPaymentRequestForm.get("Amt")?.disable();
        this.ContractorPaymentRequestForm.get("MobileNo")?.disable();
        this.ContractorPaymentRequestForm.get("TotalOutstan")?.disable();
        this.ContractorPaymentRequestForm.get("AccountOut")?.disable();
        this.ContractorPaymentRequestForm.get("TDS")?.disable();
        this.ContractorPaymentRequestForm.get("ActualPayable")?.disable();
      }
    }
  }

  // Updated loadInitialData method
  async loadInitialData() {
    try {
      this.isLoading = true;
      await Promise.all([this.getsite(), this.getContractordata()]);

      if (this._route.snapshot?.params?.id) {
        this.selectedId = this._route.snapshot?.params?.id;
        await this.getPRNDetails(this._route.snapshot?.params?.id);
      }
    } catch (error) {
      console.error('Error loading initial data:', error);
      this.snackBar.open('Error loading data', 'Close', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['if-error'],
      });
    } finally {
      this.isLoading = false;
    }
  }

  // Fix the getPRNDetails method to properly handle the response
  getPRNDetails(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sharedservice.getContractorPaymentRequestById(id).subscribe(
        (res) => {
          this.currentReceiptData = res;
          
          // Store the original contractor object for later use
          this.obj = this.Contractordata.find(
            contractor => contractor.contractorKey === res.contractorKey
          );
          
          // First fetch sub-contractor data, then initialize form
          this.fetchSUBWOByContractorId(res.contractorKey).then(() => {
            this.initializeFormWithData(res);
            this.setFormState();
            resolve(res);
          }).catch(error => {
            console.error('Error fetching sub-contractor data:', error);
            reject(error);
          });
        },
        (error) => reject(error)
      );
    });
  }

  getsite(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      this.sharedservice.getSiteData().subscribe(
        (res) => {
          this.sitedata = res;
          resolve(res);
          this.isLoading = false;
        },
        (error) => reject(error)
      );
    });
  }

  getContractordata(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sharedservice.getContractordata().subscribe(
        (res) => {
          this.Contractordata = res;
          resolve(res);
        },
        (error) => reject(error)
      );
    });
  }

  initializeForm(data): void {
    const isViewMode = this.viewType === PAGE_VIEW_TYPE.VIEW;

    this.ContractorPaymentRequestForm = this.formBuilder.group({
      site: [
        { value: data?.sitekey || "", disabled: isViewMode },
        Validators.required,
      ],
      Contractor: [
        { value: data?.sitekey || "", disabled: isViewMode },
        Validators.required,
      ],
      Subscontractor: [
        { value: data?.sitekey || "", disabled: isViewMode },
        Validators.required,
      ],
      EmailId: [{ value: "", disabled: true }],
      RequestDate: [
        { value: new Date() || "", disabled: isViewMode },
        Validators.required,
      ],
      PaidAmount: [
        { value: data?.advanceAmount || "", disabled: isViewMode },
        [
          Validators.required,
          Validators.pattern(/^\d+(\.\d{1,2})?$/),
          this.paidAmountValidator(),
        ],
      ],
      Amt: [{ value: "", disabled: true }],
      MobileNo: [{ value: "", disabled: true }],
      TotalOutstan: [{ value: "", disabled: true }],
      AccountOut: [{ value: "", disabled: true }],
      ActualPayable: [{ value: "", disabled: true }],
      // Set TDS field with tdsPer value from API data
      TDS: [{ value: data?.tdsPer || 0, disabled: true }],
      productDetails: this.formBuilder.array([]),
    });

    // Setup form subscriptions
    this.setupFormSubscriptions();
    this.addProductDetails();
  }

  // Setup form subscriptions in a separate method
  setupFormSubscriptions(): void {
    // Subscribe to TotalOutstan changes to re-validate PaidAmount
    this.ContractorPaymentRequestForm.get('TotalOutstan')?.valueChanges.subscribe(() => {
      this.ContractorPaymentRequestForm.get('PaidAmount')?.updateValueAndValidity();
    });

    // Subscribe to PaidAmount changes to calculate TDS and ActualPayable
    this.ContractorPaymentRequestForm.get('PaidAmount')?.valueChanges.subscribe(() => {
      this.calculateTDSAndActualPayable();
    });

    // Subscribe to TDS changes to recalculate ActualPayable
    this.ContractorPaymentRequestForm.get('TDS')?.valueChanges.subscribe(() => {
      this.calculateTDSAndActualPayable();
    });
  }

  addProductDetails(item?: any) {
    this.productDetails.push(this.createProductDetailGroup(item));
  }

  createProductDetailGroup(item?: any): FormGroup {
    return this.formBuilder.group({
      isSelected: [item?.isSelected || false],
      WONo: [item?.WONo || ""],
      InvoiceNo: [item?.InvoiceNo || ""],
      InvoiceDate: [item?.InvoiceDate || ""],
      PaidAmt: [
        item?.PaidAmt || "",
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      BillAmt: [item?.BillAmt || ""],
    });
  }

  // Fixed initializeFormWithData method
  initializeFormWithData(data: any): void {
    // Find matching records properly
    const matchingSite = this.sitedata.find(
      (site) => site.siteKey == data?.siteKey || site.siteId == data?.siteKey
    );

    const matchingContractor = this.Contractordata.find(
      (contractor) => contractor.contractorKey == data?.contractorKey
    );

    const matchingSubcontractor = this.dataforsubcontractor.find(
      (subcontractor) => subcontractor.subConWoKey == data?.subConWoKey
    );

    const isViewMode = this.viewType === PAGE_VIEW_TYPE.VIEW;

    // Initialize form with proper data mapping
    this.ContractorPaymentRequestForm = this.formBuilder.group({
      site: [
        { value: matchingSite?.siteName || '', disabled: isViewMode },
        Validators.required,
      ],
      Contractor: [
        { value: matchingContractor || '', disabled: isViewMode },
        Validators.required,
      ],
      Subscontractor: [
        { value: matchingSubcontractor || '', disabled: isViewMode },
        Validators.required,
      ],
      EmailId: [{ value: data?.emailId || '', disabled: true }],
      RequestDate: [
        {
          value: data?.conRecPaymentDate ? new Date(data.conRecPaymentDate) : new Date(),
          disabled: isViewMode,
        },
        Validators.required,
      ],
      PaidAmount: [
        { value: data?.paidAmount || '', disabled: isViewMode },
        [
          Validators.required,
          Validators.pattern(/^\d+(\.\d{1,2})?$/),
          this.paidAmountValidator(),
        ],
      ],
      Amt: [{ value: '', disabled: true }],
      AccountOut: [{ value: '', disabled: true }],
      TotalOutstan: [{ value: '', disabled: true }],
      MobileNo: [{ value: '', disabled: true }],
      ActualPayable: [{ value: data?.actualPayable || '', disabled: true }],
      // Set TDS field with tdsPer value from API response
      TDS: [{ value: data?.tdsPer || matchingContractor?.tdsPer || 0, disabled: true }],
      productDetails: this.formBuilder.array([]),
    });

    // Set up form subscriptions
    this.setupFormSubscriptions();

    // Handle product details - this will also set the selected checkboxes
    this.initializeProductDetails(data);

    // Set dependent values
    if (matchingSite) {
      this.setDependentValues(matchingSite);
    }

    // Calculate TDS and ActualPayable after form initialization
    this.calculateTDSAndActualPayable();
  }

  // Updated method to handle product details initialization with checkbox selection
  initializeProductDetails(data: any): void {
    const productArray = this.productDetails;
    productArray.clear();

    // Get the selected bill entry keys from the response
    const selectedBillEntryKeys = data?.conBillEntryKeysSet || [];

    if (data?.subConWoKey) {
      // Load all bill entries for this sub-contractor work order
      this.getbillentryForUpdate(data.subConWoKey, selectedBillEntryKeys);
    }
  }

  setDependentValues(siteItem: any): void {
    this.ContractorPaymentRequestForm.patchValue({
      EmailId: siteItem?.clientResponse?.EmailId || "",
      Amt: siteItem?.clientSiteEngineer || "",
      TotalOutstan: siteItem?.clientSiteEngineer || "",
      AccountOut: siteItem?.clientSiteEngineer || "",
      MobileNo: siteItem?.siteContactNumber || "",
    });
  }

  // Enhanced setDependentValuesFromData method
  setDependentValuesFromData(data: any): void {
    this.ContractorPaymentRequestForm.patchValue({
      EmailId: data?.emailId || data?.EmailId || '',
      Amt: data?.amount || data?.Amt || '',
      AccountOut: data?.accountOutstanding || data?.AccountOut || '',
      TotalOutstan: data?.totalOutstanding || data?.TotalOutstan || '',
      MobileNo: data?.mobileNo || data?.MobileNo || '',
      // Set TDS field with tdsPer value from API data
      TDS: data?.tdsPer || 0,
    });
  }

  getFormValue() {
    return { ...this.ContractorPaymentRequestForm.value };
  }

  onCheckboxChange(index: number, event: any): void {
    const isChecked = event.checked;
    const productDetail = this.productDetails.at(index);
    const billAmount = parseFloat(productDetail.get("BillAmt")?.value) || 0;
    const paidAmtValue = productDetail.get("PaidAmt")?.value;

    let paidAmount = 0;
    if (paidAmtValue && paidAmtValue !== "-") {
      paidAmount = parseFloat(paidAmtValue) || 0;
    }

    const totalSelectedBillAmt = this.calculateTotalSelectedAmount();
    const totalSelectedPaidAmt = this.calculateTotalSelectedPaidAmt();
    const totalOutstanding = totalSelectedBillAmt - totalSelectedPaidAmt;

    const patchValues: any = {
      Amt: totalSelectedBillAmt.toFixed(2),
    };
    if (totalOutstanding > 0) {
      patchValues.TotalOutstan = totalOutstanding.toFixed(2);
    }
    this.ContractorPaymentRequestForm.patchValue(patchValues);
    // Trigger validation for PaidAmount after updating TotalOutstan
    this.ContractorPaymentRequestForm.get(
      "PaidAmount"
    )?.updateValueAndValidity();
  }

  calculateTotalSelectedPaidAmt(): number {
    let total = 0;
    this.productDetails.controls.forEach((control) => {
      if (control.get("isSelected")?.value) {
        const paidAmtValue = control.get("PaidAmt")?.value;

        if (paidAmtValue && paidAmtValue !== "-") {
          const paidAmt = parseFloat(paidAmtValue) || 0;
          total += paidAmt;
        }
      }
    });
    return total;
  }

  // Getter to check if PaidAmount has validation error
  get hasPaidAmountError(): boolean {
    const paidAmountControl =
      this.ContractorPaymentRequestForm.get("PaidAmount");
    return paidAmountControl
      ? paidAmountControl.hasError("paidAmountExceedsOutstanding")
      : false;
  }

  // Getter to get the validation error message
  get paidAmountErrorMessage(): string {
    const paidAmountControl =
      this.ContractorPaymentRequestForm.get("PaidAmount");
    if (paidAmountControl?.hasError("paidAmountExceedsOutstanding")) {
      const error = paidAmountControl.getError("paidAmountExceedsOutstanding");
      return `Paid amount (${error.paidAmount}) cannot exceed total outstanding (${error.totalOutstanding})`;
    }
    return "";
  }

  onSaveAsDraft() {
    if (
      this.viewType !== PAGE_VIEW_TYPE.VIEW &&
      this.ContractorPaymentRequestForm.valid
    ) {
      const formData = { ...this.getFormValue(), isDraft: true };
      this.viewType === PAGE_VIEW_TYPE.UPDATE
        ? this.updateAdvanceReceiptForm(this.selectedId, formData)
        : this.createAdvanceReceiptForm(formData);
    } else {
      // Show validation errors
      this.markFormGroupTouched(this.ContractorPaymentRequestForm);
    }
  }

  onSave() {
    if (
      this.viewType !== PAGE_VIEW_TYPE.VIEW &&
      this.ContractorPaymentRequestForm.valid
    ) {
      const formData = this.getFormValue();
      this.viewType === PAGE_VIEW_TYPE.UPDATE
        ? this.updateAdvanceReceiptForm(this.selectedId, formData)
        : this.createAdvanceReceiptForm(formData);
    } else {
      // Show validation errors
      this.markFormGroupTouched(this.ContractorPaymentRequestForm);
    }
  }

  // Helper method to mark all form controls as touched to show validation errors
  markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  createAdvanceReceiptForm(payload) {
    const {
      PaidAmount,
      RequestDate,
      Contractor,
      isDraft,
      ActualPayable,
      Subscontractor,
      TDS,
      productDetails,
    } = payload;

    console.log("payload", payload);

    let id = productDetails
      .filter((item: any) => item?.isSelected)
      .map((item: any) => item.no);

    const tdsPercentage = parseFloat(TDS) || 0;
    const paidAmount = parseFloat(PaidAmount) || 0;
    const tdsAmount = (paidAmount * tdsPercentage) / 100;

    let actualPayable =
      this.ContractorPaymentRequestForm.get("ActualPayable")?.value || 0;
    
    // Updated payload to use tdsPer instead of just TDS
    const updatedpayloda = {
      actualPayable: actualPayable,
      branchKey: Number(this.branchId),
      conBillEntryKeysSet: id,
      conRecPaymentDate: RequestDate?.toISOString(),
      contractorKey: Contractor?.contractorKey,
      draft: isDraft || false,
      paidAmount: PaidAmount,
      siteKey: Subscontractor?.siteKey,
      subConWoKey: Subscontractor?.subConWoKey,
      // Use tdsPer as the field name for API
      tdsPer: tdsPercentage,
      tdsAmount: tdsAmount.toFixed(2),
    };

    console.log(updatedpayloda);

    this.sharedservice.createContractorPaymentRequest(updatedpayloda).subscribe(
      () => {
        this.snackBar.open(
          "Contractor Payment Request created successfully",
          "Cancel",
          {
            duration: 3000,
            verticalPosition: "top",
            panelClass: ["if-success"],
          }
        );
        this.onCancel();
      },
      (error) => {
        console.log(error);
        this.snackBar.open(error, "Cancel", {
          duration: 5000,
          verticalPosition: "top",
          panelClass: ["if-error"],
        });
      }
    );
  }

  // Updated method to create update payload
  createUpdatePayload(payload: any): any {
    const {
      PaidAmount,
      RequestDate,
      Contractor,
      isDraft,
      ActualPayable,
      Subscontractor,
      TDS,
      productDetails,
    } = payload;

    // Get selected bill entry keys
    const selectedBillEntryKeys = productDetails
      .filter((item: any) => item?.isSelected)
      .map((item: any) => item.no);

    const tdsPercentage = parseFloat(TDS) || 0;
    const paidAmount = parseFloat(PaidAmount) || 0;
    const tdsAmount = (paidAmount * tdsPercentage) / 100;
    const actualPayable = parseFloat(ActualPayable) || (paidAmount - tdsAmount);

    return {
      conRecPaymentNo: this.currentReceiptData?.conRecPaymentNo || '',
      actualPayable: actualPayable,
      branchKey: Number(this.branchId),
      conBillEntryKeysSet: selectedBillEntryKeys,
      conRecPaymentDate: RequestDate?.toISOString?.() || RequestDate,
      contractorKey: Contractor?.contractorKey || this.currentReceiptData?.contractorKey,
      draft: isDraft || false,
      paidAmount: paidAmount,
      siteKey: Subscontractor?.siteKey || this.currentReceiptData?.siteKey,
      subConWoKey: Subscontractor?.subConWoKey || this.currentReceiptData?.subConWoKey,
      // Use tdsPer as the field name for API
      tdsPer: tdsPercentage,
      tdsAmount: tdsAmount.toFixed(2),
      status: this.currentReceiptData?.status || 'PENDING_APPROVAL',
    };
  }

  // Updated updateAdvanceReceiptForm method
  updateAdvanceReceiptForm(id: any, payload: any): void {
    const updatedPayload = this.createUpdatePayload(payload);
    
    console.log('Update payload:', updatedPayload);

    this.sharedservice.updateContractorPaymentRequest(id, updatedPayload).subscribe(
      () => {
        this.snackBar.open(
          'Contractor Payment Request updated successfully',
          'Cancel',
          {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['if-success'],
          }
        );
        this.onCancel();
      },
      (error) => {
        console.error('Update error:', error);
        this.snackBar.open(
          error?.error?.message || error?.message || 'Error updating request',
          'Cancel',
          {
            duration: 5000,
            verticalPosition: 'top',
            panelClass: ['if-error'],
          }
        );
      }
    );
  }

  onCancel() {
    this._router.navigate([`/subContractor/contractor-payment-request`]);
  }

approvePRN(id) {
  let data: ConfirmationDialog = {
    title: "Approve Contractor Payment Request",
    message: "Do you want to approve Contractor Payment Request?",
    yes: "Yes",
    no: "No",
  };
  const dialogRef = this.dialog.open(ConfirmationWithReasonComponent, {
    width: "400px",
    position: { top: "200px" },
    data: data,
  });
  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.sharedservice
        .ContractorPaymentRequestApprove(id, { reason: result.form?.reason || "string" })
        .subscribe(
          () => {
            this.snackBar.open(
              "Contractor Payment Request approved successfully",
              "Cancel",
              {
                duration: 3000,
                verticalPosition: "top",
                panelClass: ["if-success"],
              }
            );
            this.onCancel();
          },
          (error) => {
            this.snackBar.open(error.message, "Cancel", {
              duration: 5000,
              verticalPosition: "top",
              panelClass: ["if-error"],
            });
          }
        );
    }
  });
}

rejectPRN(id) {
  let data: ConfirmationDialog = {
    title: "Reject Contractor Payment Request",
    message: "Do you want to reject Contractor Payment Request?",
    yes: "Yes",
    no: "No",
  };
  const dialogRef = this.dialog.open(ConfirmationWithReasonComponent, {
    width: "400px",
    position: { top: "200px" },
    data: data,
  });
  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.sharedservice
        .ContractorPaymentRequestReject(id, { reason: result.form?.reason || "string" })
        .subscribe(
          () => {
            this.snackBar.open(
              "Contractor Payment Request rejected successfully",
              "Cancel",
              {
                duration: 3000,
                verticalPosition: "top",
                panelClass: ["if-success"],
              }
            );
            this.onCancel();
          },
          (error) => {
            this.snackBar.open(error.message, "Cancel", {
              duration: 5000,
              verticalPosition: "top",
              panelClass: ["if-error"],
            });
          }
        );
    }
  });
}

  get isFormDisabled(): boolean {
    return this.viewType === PAGE_VIEW_TYPE.VIEW;
  }

  get productDetails(): FormArray {
    return this.ContractorPaymentRequestForm.get("productDetails") as FormArray;
  }

  // Method to refresh form data after API calls
  refreshFormData(): void {
    if (this.currentReceiptData) {
      this.initializeFormWithData(this.currentReceiptData);
    }
  }
}